<template>
  <b-card-code title="Tambah Satuan Kerja" v-if="kotaProvinsi">
    <validation-observer ref="simpleRules">
      <b-form>
        <b-row>
          <b-col md="12">
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="ID Satuan Kerja"
                rules="required"
              >
                <label for="">ID Satuan Kerja</label>
                <b-form-input
                  v-model="model.idSatker"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Masukkan"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="SatuanKerja"
                rules="required"
              >
                <label for="">Satuan Kerja</label>
                <b-form-input
                  v-model="model.satker"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Masukkan"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <validation-provider
              #default="{ errors }"
              name="Perusaan Induk"
              rules="required"
            >
              <b-form-group
                label="Kota"
                label-for="Kota"
                :state="errors.length > 0 ? false : null"
              >
                <v-select
                  id="induk"
                  v-model="selected"
                  :options="kotaProvinsi"
                  label="kotaName"
                  :clearable="false"
                  @input="change"
                />
                <b-form-invalid-feedback
                  :state="errors.length > 0 ? false : null"
                >
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col>
            <b-form-group>
              <label for="">NamaProvinsi</label>
              <b-form-input v-model="provinsi" disabled />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <div class="d-flex align-items-center justify-content-end mt-1">
              <b-button
                variant="outline-secondary"
                class="mr-1"
                :to="{ name: 'satuan-kerja' }"
              >
                <span class="text-nowrap">Batal</span>
              </b-button>
              <b-button
                variant="primary"
                type="submit"
                @click.prevent="validationForm"
              >
                <span class="text-nowrap">Tambah</span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card-code>
</template>

<script>
import BCardCode from '@core/components/b-card-code';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required } from '@validations';
import vSelect from 'vue-select';
import { mapGetters } from 'vuex';

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    vSelect,
    BCardCode,
  },

  data() {
    return {
      file1: null,
      model: {},
      selected: null,
      provinsi: null,
      required,
    };
  },
  computed: {
    ...mapGetters('user', ['kotaProvinsi']),
  },
  async created() {
    await this.getKota();
  },
  methods: {
    validationForm() {
      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          // eslint-disable-next-line
          this.confirmText();
        }
      });
    },
    async getKota() {
      await this.$store.dispatch('user/getKotaProvinsi');
    },
    change() {
      this.provinsi = this.selected.provinsiName;
    },
    async create() {
      const data = {
        Id_Satker: this.model.idSatker,
        Satker: this.model.satker,
        Kota: this.selected.kota.toString(),
        Provinsi: this.selected.provinsi.toString(),
      };

      const response = await this.$store.dispatch(
        'satuankerja/createSatuanKerja',
        data
      );

      if (response.status == 200) {
        this.$swal
          .fire('Data Berhasil di Disimpan!', '', 'success')
          .then(() => {
            this.$router.push('/satuan-kerja');
          });
      }
    },
    confirmText() {
      this.$swal({
        title: 'Simpan Data?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ya, simpan data!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.create();
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
